<section [class.py-5]="!noPadding()" [class.px-8]="!noPadding()">
  <ng-content></ng-content>
</section>
